// LocalStorage persistence layer for signed waivers.
const STORAGE_KEY = 'hbc_waivers_v1';

export function loadWaivers() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveWaiver(waiver) {
  const list = loadWaivers();
  list.unshift(waiver);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  return list;
}

export function deleteWaiver(id) {
  const list = loadWaivers().filter((w) => w.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  return list;
}

export function clearAllWaivers() {
  localStorage.removeItem(STORAGE_KEY);
}

export function generateId() {
  return `w_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}
